<app-topbar />
<main class="app-main">
  <router-outlet />
</main>
<app-notifications />
